const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icono",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0,23.39v44.91c0,2.71,2.19,4.9,4.9,4.9h70.19c2.71,0,4.91-2.19,4.91-4.9V23.39H0ZM56.73,32.6h9.86c1.1,0,2,.9,2,2s-.9,2-2,2h-9.86c-1.1,0-2-.9-2-2s.9-2,2-2ZM56.73,45.22h9.86c1.1,0,2,.89,2,2s-.9,2-2,2h-9.86c-1.1,0-2-.9-2-2s.9-2,2-2ZM56.73,57.84h9.86c1.1,0,2,.89,2,2s-.9,2-2,2h-9.86c-1.1,0-2-.9-2-2s.9-2,2-2ZM35.87,32.6h9.86c1.1,0,2,.9,2,2s-.9,2-2,2h-9.86c-1.11,0-2-.9-2-2s.89-2,2-2ZM35.87,45.22h9.86c1.1,0,2,.89,2,2s-.9,2-2,2h-9.86c-1.11,0-2-.9-2-2s.89-2,2-2ZM35.87,57.84h9.86c1.1,0,2,.89,2,2s-.9,2-2,2h-9.86c-1.11,0-2-.9-2-2s.89-2,2-2ZM15.01,32.6h9.85c1.11,0,2,.9,2,2s-.89,2-2,2h-9.85c-1.11,0-2-.9-2-2s.89-2,2-2ZM15.01,45.22h9.85c1.11,0,2,.89,2,2s-.89,2-2,2h-9.85c-1.11,0-2-.9-2-2s.89-2,2-2ZM15.01,57.84h9.85c1.11,0,2,.89,2,2s-.89,2-2,2h-9.85c-1.11,0-2-.9-2-2s.89-2,2-2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,14.56v4.83H0v-4.83C0,11.85,2.19,9.66,4.9,9.66h12.54v-2.86c0-1.11.89-2,2-2s2,.89,2,2v2.86h37.11v-2.86c0-1.11.9-2,2-2s2,.89,2,2v2.86h12.54c2.71,0,4.91,2.19,4.91,4.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.3472cf64ad735808db095c7f81335413.svg";
export { ForwardRef as ReactComponent };